// Rótulos de la división administrativa del país de operación ("Región"/"Comuna" en
// Chile, "Provincia"/"Municipio" en Argentina) que expone `useCountry().labels`.
//
// El catálogo los entrega en SINGULAR, así que cualquier frase en plural tiene que
// derivarlo. Vive acá porque lo comparten la pestaña de cobertura (donde se declaran) y
// el editor de tarifas por comuna (que solo ofrece las cubiertas).

/**
 * Plural español de un rótulo de división administrativa:
 * Región→Regiones, Provincia→Provincias, Comuna→Comunas, Municipio→Municipios,
 * Distrito→Distritos, Departamento→Departamentos.
 *
 * No es un pluralizador general del español: solo cubre el vocabulario cerrado de
 * `divisionLabels` del catálogo de países.
 */
export function pluralize(word) {
  const w = String(word || "");
  if (!w) return w;
  if (/ión$/i.test(w)) return w.replace(/ión$/i, "iones");
  if (/[aeiouáéíóú]$/i.test(w)) return `${w}s`;
  return `${w}es`;
}

export default pluralize;
